import { dispatch } from "@rematch/core";
import React from "react";
import { Button, Header, Tab, Popup, Icon } from "semantic-ui-react";
import LoadingComponent from "../../../../common/LoadingComponent";
import ConsumptionTable from "./ConsumptionTable";
import { startOfMonth, format, subMonths } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
const USAGE_ACTIVITY_MAP = [
  {
    key: "playbooksCreated",
    activityName: "Playbooks Created",
    defaultKey: "playbookCreated",
  },
  {
    key: "playbooksGenerated",
    activityName: "Playbooks Generated",
    defaultKey: "playbooksGenerated",
  },
  {
    key: "playbooksPublished",
    activityName: "Playbooks Published",
    defaultKey: "playbookPublished",
  },
  {
    key: "playbookExported",
    activityName: "Playbooks Exported",
    defaultKey: "playbookExported",
  },
  {
    key: "activitiesGenerated",
    activityName: "Activities Generated",
    defaultKey: "activitiesGenerated",
  },
  {
    key: "linksGenerated",
    activityName: "Links Generated",
    defaultKey: "linksGenerated",
  },
  {
    key: "initiativeCreated",
    activityName: "Initiatives Created",
    defaultKey: "initiativeCreated",
  },
  {
    key: "teamsCreated",
    activityName: "Teams Created",
    defaultKey: "teamsCreated",
  },
  {
    key: "scenarioExecution",
    activityName: "Scenario Executions",
    defaultKey: "scenarioExecution",
  },
];

export default class ConsumptionUsages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      showDropdown: false,
      loading: false,
      isMounted: false,
      consumptionDetailsGrouped: [],
      isDatePickerOpen: false,
      consumptionDetailsChart: {
        playbooksCreated: [],
        playbooksGenerated: [],
        playbooksPublished: [],
        activitiesGenerated: [],
        playbookExported: [],
        linksGenerated: [],
        initiativeCreated: [],
        // invitesCreated: [],
        // invitesUpdated: [],
        teamsCreated: [],
        scenarioExecution: [],
      },
    };
  }

  setPreset = async (key) => {
    this.setState({ selectedRange: key });
    const today = new Date();
    let startDate = subMonths(today, 1);
    let endDate = today;
    if(this.props.accountSubscriptionDetail && this.props.accountSubscriptionDetail.createdAt && this.props.accountSubscriptionDetail.planExpiryDate){
      startDate = new Date(this.props.accountSubscriptionDetail.createdAt)
      endDate = new Date(this.props.accountSubscriptionDetail.planExpiryDate)
    }
    const payload = {
      from_date: format(new Date(startDate), "yyyy-MM-dd"),
      to_date: format(new Date(endDate), "yyyy-MM-dd"),
      //   selectedAccountId: this.props.selectedAccount._id,
    };
    if (
      this.state.selectedWorkspace &&
      this.state.selectedWorkspace !== "all"
    ) {
      payload.selectedOrganizationId = this.state.selectedWorkspace;
    }
    await dispatch.account.getConsumptionDetails(payload);
  };
  manageSubscription = async () => {
    const payload = {
          customerId: this.props.selectedAccount.customerId,
          accountId: this.props.selectedAccount._id
        };
    await dispatch.account.subscriptionUpgradeService(payload);
  }
  upgradePlans = async () => {
    this.props.history.push(`/app/${this.props.selectedAccount._id}/upgrade`);
  }
  async componentDidUpdate(prevProps) {
    if (
      prevProps.consumptionDetails !== this.props.consumptionDetails &&
      this.props.consumptionDetails.length > 0
    ) {
      const consumptionDetailsChart = {
        playbooksCreated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookCreated",
        ),

        playbooksGenerated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookComplete",
        ),

        activitiesGenerated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookComplete",
        ),

        playbooksPublished: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookPublished",
        ),

        playbookExported: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookExported",
        ),

        linksGenerated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "ActivityDetailsGenerated",
        ),

        initiativeCreated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "InitiativeCreated",
        ),

        teamsCreated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "TeamCreated",
        ),
        scenarioExecution: this.props.consumptionDetails.filter(
          (item) => item.data.event === "ScenarioExecution",
        ),
      };
      this.setState({ consumptionDetailsChart });
    } else if (
      prevProps.consumptionDetails !== this.props.consumptionDetails &&
      this.props.consumptionDetails.length === 0
    ) {
      this.setState({
        consumptionDetailsChart: {
          playbooksCreated: [],
          playbooksGenerated: [],
          playbooksPublished: [],
          activitiesGenerated: [],
          playbookExported: [],
          linksGenerated: [],
          initiativeCreated: [],
          // invitesCreated: [],
          // invitesUpdated: [],
          teamsCreated: [],
          scenarioExecution: [],
        },
      });
    }
  }
  async componentWillMount() {
    this.setState({ loading: true });
    await this.setPreset();
    this.setState({
      loading: false,
    });
  }

  render() {
    const accountSubscriptionDetail =
      this.props.accountSubscriptionDetail || {};
    
    const dateString = accountSubscriptionDetail && accountSubscriptionDetail.createdAt && accountSubscriptionDetail.planExpiryDate ?`${format(new Date(accountSubscriptionDetail.createdAt), "dd MMM yyyy")} - ${format(new Date(accountSubscriptionDetail.planExpiryDate), "dd MMM yyyy")}` : format(startOfMonth(new Date()), "MMMM yyyy");
    const usedCredits =
      accountSubscriptionDetail.usageMeter &&
      accountSubscriptionDetail.usageMeter.currentUsage
        ? accountSubscriptionDetail.usageMeter.currentUsage
        : 0;
    const totalCreditsAllowed =
      accountSubscriptionDetail.usageMeter &&
      accountSubscriptionDetail.usageMeter.allowedLimit
        ? accountSubscriptionDetail.usageMeter.allowedLimit
        : 0;
    const usagePercent = totalCreditsAllowed
      ? Math.min((usedCredits / totalCreditsAllowed) * 100, 100)
      : 0;
    const barColor = totalCreditsAllowed < 0 ? "#2185d0" :
      usagePercent > 85 ? "#db2828" : usagePercent > 65 ? "#fbbd08" : "#2185d0";
    const selectedAccount = this.props.selectedAccount || {};
    const freeCreditsRemaining = selectedAccount.freeCreditsRemaining || 0;
    const user = this.props.user;
    const isCustomerAdmin = user && user.accounts && user.accounts.some(
      (account) => account.id && account.id.toString() === (selectedAccount._id || "").toString() && account.role === 'customerAdmin'
    );
    const { consumptionDetailsChart } = this.state;
    const defaults = accountSubscriptionDetail.consumptionDefaults || {};
    const usageByActivityConfig = USAGE_ACTIVITY_MAP.map((item) => {
      let timesUsed = consumptionDetailsChart[item.key]
        ? consumptionDetailsChart[item.key].length
        : 0;
      if (item.key === "activitiesGenerated") {
        timesUsed = 0;
        if (
          consumptionDetailsChart[item.key] &&
          consumptionDetailsChart[item.key].length > 0
        ) {
          for (const entry of consumptionDetailsChart[item.key]) {
            timesUsed += entry.data.activitiesGenerated || 0;
          }
        }
      }
      if (item.key === "linksGenerated") {
        timesUsed = 0;
        if (
          consumptionDetailsChart[item.key] &&
          consumptionDetailsChart[item.key].length > 0
        ) {
          for (const entry of consumptionDetailsChart[item.key]) {
            timesUsed += entry.data.linksGenerated || 0;
          }
        }
      }
      const creditsPerAction = defaults[item.defaultKey] || 0;

      return {
        activityName: item.activityName,
        timesUsed,
        creditsPerAction,
        totalCreditsUsed: timesUsed * creditsPerAction,
      };
    });
    const usageByActivityColumns = [
      {
        Header: "Activity",
        accessor: "activityName",
        id: "activityName",
        Cell: ({ value }) => <strong>{value}</strong>,
        width: 220,
      },
      {
        Header: "Times Used",
        accessor: "timesUsed",
        id: "timesUsed",
        Cell: ({ value }) => value,
        width: 140,
      },
      {
        Header: "Credits per Action",
        accessor: "creditsPerAction",
        id: "creditsPerAction",
        Cell: ({ value }) => (value === 0 ? "Free" : value),
        width: 180,
      },
      {
        Header: "Total Credits Used",
        accessor: "totalCreditsUsed",
        id: "totalCreditsUsed",
        Cell: ({ value }) => <strong>{value}</strong>,
        width: 180,
      },
    ];

    return (
      <div>
        <LoadingComponent
          active={this.props.loadingConsumptions || this.state.loading}
          message="Loading Consumption Details"
        />
        <div style={{ border: "0.5px solid #D3D3D3" }}>
          <Header
            as="h4"
            style={{
              backgroundColor: "#f4f4f4ff",
              border: "0.5px solid #D3D3D3",
              padding: "7px",
            }}
          >
            Usages & Limits
          </Header>
          <div
            style={{
              padding: "5px",
              marginTop: "15px",
              marginBottom: "15px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "100%", marginRight: "20px" }}>
              <div>
                <Header as="h4">
                  Consumption Usage for {" "}
                  {dateString}
                </Header>
              </div>
              <div style={{ marginTop: "10px" }}>
                <ConsumptionTable
                  data={usageByActivityConfig}
                  column={usageByActivityColumns}
                />
              </div>
            </div>
            <div
              style={{
                width: "260px",
                border: "1px solid #D3D3D3",
                borderRadius: "6px",
                padding: "10px",
              }}
            >
              <p style={{ marginBottom: "4px", fontWeight: 600 }}>
                Credits Usage
              </p>

              <p style={{ margin: "0", color: "#555" }}>
                Remaining: <strong>{totalCreditsAllowed - usedCredits > 0 ? totalCreditsAllowed - usedCredits : "∞"}</strong>{" "}
                credits
              </p>

              <div
                style={{
                  marginTop: "8px",
                  height: "8px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "6px",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: `${totalCreditsAllowed > 0 ? usagePercent : "100"}%`,
                    height: "100%",
                    backgroundColor: barColor,
                    transition: "width 0.4s ease",
                  }}
                />
              </div>

              <p style={{ marginTop: "6px", fontSize: "12px", color: "#777" }}>
                <strong>
                  {usedCredits} of {totalCreditsAllowed > 0 ? totalCreditsAllowed : "∞"} used
                </strong>
              </p>
              <Button className="button-submit" style={{ width: "100%" }} onClick={this.manageSubscription}>Manage Subscription</Button>
              <Button className="button-submit" style={{ width: "100%",marginTop:"5px" }} onClick={this.upgradePlans}>Upgrade Plans</Button>
              {isCustomerAdmin && selectedAccount.planDisplayName !== "Free" && (<p style={{ margin: "6px 0 0", fontSize: "12px", color: "#777" }}>
                <strong>Reserved Credits Coming Soon</strong>{" "}
                <Popup
                  hoverable
                  wide
                  position="top center"
                  trigger={<Icon name="info circle" style={{ cursor: "pointer" }} />}
                  content="Reserve credits enable you to have a buffer in case your monthly credits run out before the end of the billing period."
                />
              </p>)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
